export default __webpack_public_path__ + "double-strikethrough-option.png";